export function toNano(amount: number | string): number {
  return Number(amount) * 1_000_000_000
}

export function fromNano(nanoAmount: number | string): number {
  return Number(nanoAmount) / 1_000_000_000
}

export function toDecimal(amount: number | string, decimals: number): number {
  return Number(amount) * 10 ** decimals
}

export function fromDecimal(amount: number | string, decimals: number): number {
  return Number(amount) / 10 ** decimals
}
